export const VOICE_MODEL_OPTIONS = [
  { value: '', label: 'Predeterminada' },
  { value: 'Antioquia', label: 'Antioquia' },
  { value: 'Caribe', label: 'Caribe' },
  { value: 'Bogota', label: 'Bogota' },
  { value: 'Republica Dominicana', label: 'Republica Dominicana' },
];
